<template lang="pug">
.sub_visual(:class='titleClass')
  .in
    .txt
      h2 {{ titleText }}
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['lan']),
    titleText() {
      let name = this.$route.name;
      let text = '';
      if (name) {
        let nameArr = name.split('-');
        if (this.lan == 'en') {
          switch (nameArr[nameArr.length - 1]) {
            case 'info':
              text = 'Company';
              break;
            case 'store':
              text = 'Find INTHEKEG';
              break;
            default:
          }
        } else {
          switch (nameArr[nameArr.length - 1]) {
            case 'info':
              text = '회사소개';
              break;
            case 'store':
              text = '설치매장';
              break;
            default:
          }
        }
        switch (nameArr[nameArr.length - 1]) {
          case 'news':
            text = 'NEWS';
            break;
          case 'smart':
            text = 'Smart Brewery';
            break;
          case 'nano':
            text = 'Nano Brewery';
            break;
          case 'contact':
            text = 'CONTACT';
            break;
          case 'login':
            text = '관리자';
            break;
          default:
        }
        return text;
      }
      return;
    },
    titleClass() {
      let name = this.$route.name;
      if (name) {
        let splitIndex = name.lastIndexOf('-') + 1;
        name = name.substr(splitIndex);
      }

      return name;
    },
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.sub_visual {
  text-align: center;
  min-height: 430px;
  padding-top: 245px;
  color: #fff;
}
.info {
  background: url('https://office--file.s3.ap-northeast-2.amazonaws.com/img/sub_visual_1.jpg')
    no-repeat center top;
  background-position: 50% top !important;
}
.login {
  background: url('https://office--file.s3.ap-northeast-2.amazonaws.com/img/sub_visual_1.jpg')
    no-repeat center top;
}
.smart {
  background: url('https://office--file.s3.ap-northeast-2.amazonaws.com/img/sub_visual_2.jpg')
    no-repeat center top;
}
.nano {
  background: url('https://office--file.s3.ap-northeast-2.amazonaws.com/img/sub_visual_3.jpg')
    no-repeat center top;
  background-position: 50% top !important;
}
.news {
  background: url('https://office--file.s3.ap-northeast-2.amazonaws.com/img/sub_visual_4.jpg')
    no-repeat center top;
}
.store {
  background: url('https://office--file.s3.ap-northeast-2.amazonaws.com/img/sub_visual_5.jpg')
    no-repeat center top;
}
.contact {
  background: url('https://office--file.s3.ap-northeast-2.amazonaws.com/img/sub_visual_6.jpg')
    no-repeat center top;
}
.sub_visual h2 {
  font-size: 48px;
  font-weight: 600;
}

@media (max-width: 1200px) {
  .sub_visual {
    min-height: 430px;
  }
}
@media (max-width: 1024px) {
  .sub_visual {
    min-height: 330px;
    background-size: cover;
    padding-top: 140px;
    margin-top: 60px;
  }
  .sub_visual h2 {
    font-size: 42px;
  }
}
@media (max-width: 768px) {
  .sub_visual {
    min-height: 230px;
    padding-top: 95px;
    background-position: 70% center;
  }
  .sub_visual h2 {
    font-size: 34px;
  }
}
</style>
